import { HealthPill } from './HealthPill';
import { StatusDot, StatusTone } from './StatusDot';

export const healthTone = (sync: string, health: string): StatusTone => {
  if (sync === 'OutOfSync' || ['Degraded', 'Missing'].includes(health)) {
    return 'danger';
  }
  if (['Progressing', 'Suspended'].includes(health) || sync === 'Unknown') {
    return 'warning';
  }
  if (sync === 'Synced' && health === 'Healthy') return 'success';
  return 'neutral';
};

export const HealthValue = ({
  sync,
  health,
}: {
  sync?: string;
  health?: string;
}) => {
  if (!sync || !health) {
    return (
      <span style={{ fontSize: 12, color: 'var(--bui-fg-secondary)' }}>
        checking…
      </span>
    );
  }
  const tone = healthTone(sync, health);
  return (
    <HealthPill tone={tone} icon={<StatusDot tone={tone} />}>
      {sync} · {health}
    </HealthPill>
  );
};
